import Model from './Model'

export default class File extends Model {

    schema() {
        return {
            id: null,
            shop_id: null,
            filename: null,
            path: null,
            mime: null,
            size: null,
            created_at: null,
            updated_at: null,
            order: null,
            name: null,
            description: null,
            category: null,
        }
    }

}
